class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;

    this.trigger = document.getElementById(`BuyButtons-${this.sectionId}`);
    this.mainForm = document.getElementById(`product-form-${this.sectionId}`);
    this.mainButton = this.mainForm ? this.mainForm.querySelector('[name="add"]') : null;
    this.mainPrice = document.getElementById(`price-${this.sectionId}`);

    this.button = this.querySelector('.sticky-add-to-cart__button');
    this.buttonText = this.querySelector('.sticky-add-to-cart__button-text');
    this.buttonSpinner = this.querySelector('.sticky-add-to-cart__button .loading-overlay__spinner');
    this.price = this.querySelector('.sticky-add-to-cart__price');

    if (!this.trigger || !this.mainButton) return;

    this.scrollsToOptions = this.button && this.button.hasAttribute('data-scroll-to-options');

    this.createVisibilityObserver();
    this.mirrorPrice();
    this.mirrorButton();
    this.bindOptionsButton();
  }

  disconnectedCallback() {
    if (this.visibilityObserver) this.visibilityObserver.disconnect();
    if (this.priceObserver) this.priceObserver.disconnect();
    if (this.buttonObserver) this.buttonObserver.disconnect();

    if (this.onOptionsClick) this.button.removeEventListener('click', this.onOptionsClick);
  }

  createVisibilityObserver() {
    this.visibilityObserver = new IntersectionObserver(
      (entries) => {
        const scrolledPast = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        this.classList.toggle('sticky-add-to-cart--visible', scrolledPast);
      },
      { rootMargin: '0px 0px -80px 0px' }
    );

    this.visibilityObserver.observe(this.trigger);
  }

  mirrorPrice() {
    if (!this.price || !this.mainPrice) return;

    this.priceObserver = new MutationObserver(() => {
      this.price.innerHTML = this.mainPrice.innerHTML;
    });

    this.priceObserver.observe(this.mainPrice, { childList: true, subtree: true });
  }

  mirrorButton() {
    if (!this.button || this.scrollsToOptions) return;

    this.buttonObserver = new MutationObserver(this.syncButton.bind(this));
    this.buttonObserver.observe(this.mainButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true
    });
  }

  syncButton() {
    const disabled = this.mainButton.hasAttribute('disabled');
    if (disabled) {
      this.button.setAttribute('disabled', 'disabled');
    } else {
      this.button.removeAttribute('disabled');
    }

    const ariaDisabled = this.mainButton.getAttribute('aria-disabled');
    if (ariaDisabled) {
      this.button.setAttribute('aria-disabled', ariaDisabled);
    } else {
      this.button.removeAttribute('aria-disabled');
    }

    this.button.classList.toggle('loading', this.mainButton.classList.contains('loading'));

    const mainSpinner = this.mainButton.querySelector('.loading-overlay__spinner');
    if (this.buttonSpinner && mainSpinner) {
      this.buttonSpinner.classList.toggle('hidden', mainSpinner.classList.contains('hidden'));
    }

    const mainText = this.mainButton.querySelector('span');
    if (this.buttonText && mainText) this.buttonText.textContent = mainText.textContent;
  }

  bindOptionsButton() {
    if (!this.scrollsToOptions) return;

    this.onOptionsClick = (event) => {
      event.preventDefault();

      const target = document.querySelector('.main-product__option-value-selectors') || this.trigger;
      const stickyHeader = document.querySelector('sticky-header');
      const offset = stickyHeader ? stickyHeader.offsetHeight + 16 : 16;

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - offset,
        behavior: 'smooth'
      });

      const focusable = target.querySelector('select, input');
      if (focusable) focusable.focus({ preventScroll: true });
    };

    this.button.addEventListener('click', this.onOptionsClick);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
